import { AxiosError, AxiosResponse } from "axios";

import { PROJECTS_API_ENDPOINTS } from "@/features/portfolio/api/endpoints";
import apiRequests from "@/shared/config/axiosConfig";

import { AddConceptModel } from "../models/addConceptModel";

export default async function addConcept(
  project: AddConceptModel
): Promise<AddConceptModel> {
  // @important appending type, which is always 2 for concepts
  const projectWithType = { ...project, type: 2 };

  try {
    const url = PROJECTS_API_ENDPOINTS.GET_PROJECTS;

    const response: AxiosResponse<AddConceptModel> = await apiRequests.post(
      url,
      projectWithType
    );

    const { data, status } = response;

    if (status >= 200 && status < 300) {
      return data;
    }
    throw new Error(`Unexpected status code: ${status}`);
  } catch (e) {
    // @todo Handle Error Below
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
